import { useTranslation } from 'react-i18next'
import { PlaceholderPage } from '@/shared/components/PlaceholderPage.tsx'

export function ManagersPage() {
  const { t } = useTranslation()
  return <PlaceholderPage title={t('nav.managers')} description={t('pages.managers.description')} />
}
